// Original prompts for the September 2026 expansion. Finish “Drink if you think…”
const packs = {
  'new friends': [
    'you would be better at talking your way into a sold-out show.',
    'you could make a stranger laugh faster.',
    'you would survive longer with a phone at 1%.',
    'you give better restaurant recommendations.',
    'you would be the first to befriend the neighbor’s dog.',
    'you could pack for a week in a backpack.',
    'you would turn a missed flight into an adventure.',
    'you would be a better tour guide for your hometown.',
    'you could keep a houseplant alive longer.',
    'you are harder to impress with a magic trick.',
    'you would do better on a game show with no preparation.',
    'you have a more oddly specific hidden talent.',
    'you could guess someone’s coffee order more accurately.',
    'you would enjoy a surprise party more.',
    'you would win a contest for the best terrible pun.',
    'you could find the best thrift-store outfit in ten minutes.',
    'you would make a better voice for a cartoon villain.',
    'you would start a conversation in a very long elevator ride.',
    'you could name more songs from their first three seconds.',
    'you would be better at building furniture without instructions.',
    'you would get more competitive at mini golf.',
    'you would pick a better movie for a room full of strangers.',
    'you would take longer to choose a karaoke song.',
    'you would become a regular at a new café faster.',
    'you would have more fun getting lost in a new city.'
  ],
  'old friends': [
    'you are the reason the group chat is still alive.',
    'you would be first to suggest a reunion and last to book it.',
    'you remember more of your friends’ embarrassing phases.',
    'you would keep a surprise trip secret longer.',
    'you have the more chaotic camera roll.',
    'you would get the group out of an escape room.',
    'you are more likely to turn a quick errand into a whole day out.',
    'you would be the better emergency contact for a minor crisis.',
    'you have repeated the same story to this group more often.',
    'you would overpack for a one-night stay.',
    'you would be the first friend to get a very niche hobby.',
    'you have the most accurate impression of someone in this room.',
    'you would organize the itinerary and then ignore it.',
    'you are more likely to send a voice note that should have been a podcast.',
    'you would make a better documentary about this friend group.',
    'you would notice first if a friend got a tiny haircut.',
    'you would arrive with snacks nobody asked for but everyone needed.',
    'you would be the first to fall asleep during the movie night you planned.',
    'you would make a better teammate in a trivia final.',
    'you have a better excuse for being five minutes late.',
    'you would keep a group vacation spreadsheet more organized.',
    'you are more likely to insist that one more episode is a good idea.',
    'you would accidentally become the leader of a walking tour.',
    'you could identify more friends just from their laugh.',
    'you would make the better speech at a friend’s wedding.'
  ],
  family: [
    'you would win a family recipe cook-off.',
    'you know more of the family’s old stories.',
    'you would be better at teaching a grandparent a new app.',
    'you would sneak an extra dessert before dinner.',
    'you would be the first to suggest a family board game.',
    'you would get more competitive over a jigsaw puzzle.',
    'you could find the oldest photo in the family albums.',
    'you would be the best at assembling a holiday meal from leftovers.',
    'you would remember more birthdays without reminders.',
    'you would be the first to adopt a stray animal.',
    'you would tell a bedtime story with more dramatic voices.',
    'you could build a better blanket fort.',
    'you would take the longest to say goodbye at a family gathering.',
    'you would make the better road-trip playlist.',
    'you would be the first to ask if everyone has eaten.',
    'you would bring the most practical gift to a gift exchange.',
    'you would keep a childhood toy for the longest.',
    'you would be the best at remembering everyone’s favorite snack.',
    'you would cheat at hide-and-seek by choosing an impossible spot.',
    'you would be the last to take down holiday decorations.',
    'you would win a contest for the most dramatic sneeze.',
    'you would insist an old family recipe needs no measurements.',
    'you would take more photos than you appear in.',
    'you would make the better team captain on family game night.',
    'you would laugh first while trying to take a serious family photo.'
  ],
  'new couples': [
    'you would plan a more memorable date with twenty dollars.',
    'you would be the first to steal the other person’s hoodie.',
    'you could guess the other person’s comfort movie.',
    'you would be more nervous meeting the other person’s friends.',
    'you would take longer to choose a photo of the two of you.',
    'you would remember the exact first thing the other person said.',
    'you would make a better homemade birthday gift.',
    'you would choose the more adventurous item on a menu.',
    'you would be first to suggest a spontaneous weekend away.',
    'you would be better at keeping a surprise date secret.',
    'you would send the first text after a really good date.',
    'you would have a more embarrassing first-date story.',
    'you would make a better breakfast for the other person.',
    'you would notice a change in the other person’s mood faster.',
    'you would have more fun taking a dance class together.',
    'you would write the more thoughtful birthday card.',
    'you would ask for directions first on a trip together.',
    'you would be more likely to save a ticket from your first date.',
    'you would introduce the other person to a new favorite food.',
    'you would choose a better rainy-day date.',
    'you would be the first to suggest matching Halloween costumes.',
    'you would take better candid photos of the other person.',
    'you would enjoy a date with no phones more.',
    'you would be better at choosing a song for the other person.',
    'you would remember the outfit the other person wore when you met.'
  ],
  'old couples': [
    'you could order for the other person without asking.',
    'you are more likely to say “we have food at home.”',
    'you would win a quiz about your first year together.',
    'you have claimed more than half of the closet.',
    'you would be first to notice the thermostat changed.',
    'you are more likely to start a home project on a Sunday evening.',
    'you would be better at packing the car for a road trip.',
    'you would predict the ending of your shared TV show first.',
    'you are more likely to bring up an inside joke at the wrong time.',
    'you would make the better retirement travel plan.',
    'you have the stronger opinion about how to load the dishwasher.',
    'you are more likely to fall asleep with the lights on.',
    'you could describe the other person’s dream day more accurately.',
    'you would remember where the other person left their keys.',
    'you are more likely to turn a small grocery shop into a full cart.',
    'you would make the better “things we should do someday” list.',
    'you would be first to give a household appliance a nickname.',
    'you would be better at spotting when the other person needs a break.',
    'you are more attached to your side of the bed.',
    'you would be more emotional watching old videos of the two of you.',
    'you would plan the better anniversary without spending money.',
    'you would be first to suggest rewatching a show you already know by heart.',
    'you have used “just five more minutes” more often.',
    'you would write a funnier user manual for living with the other person.',
    'you would still choose the other person as your trivia partner.'
  ],
  'hot takes': [
    'a voice note longer than two minutes should come with chapters.',
    'the best part of a wedding is the dance floor.',
    'breakfast food deserves to be eaten at every meal.',
    'being early is just waiting somewhere less comfortable.',
    'a holiday needs at least one completely unplanned day.',
    'the person who cooks should choose the music.',
    'movie trailers give away too much.',
    'a good sandwich beats a fancy dinner.',
    'the window seat is worth the awkward trip to the bathroom.',
    'people who say “I’m easy, you choose” should lose veto power.',
    'a handwritten note is better than an expensive gift.',
    'every group trip needs one designated decision-maker.',
    'the opening act is sometimes better than the headliner.',
    'it is fine to leave a party without a farewell tour.',
    'the best songs are the ones everyone can sing badly.',
    'a walk counts as a perfectly good first date.',
    'dessert should be ordered before everyone gets too full.',
    'the sequel almost never needs to exist.',
    'a pet should be allowed on the couch.',
    'small talk is underrated.',
    'a silly tradition is still a tradition worth keeping.',
    'the best seat in a restaurant faces the room.',
    'a picnic is mostly an excuse to eat snacks outside.',
    'reading the rules out loud is a heroic act.',
    'winning a friendly game makes it at least a little more fun.'
  ]
};

export default Object.entries(packs).flatMap(([type, prompts], group) =>
  prompts.map((prompt, index) => ({
    id: `expansion-${group}-${index}`,
    description: `Drink if you think ${prompt}`,
    type,
    explicit: false,
    fresh: true,
  }))
);
